export default {
    getHomeGenerators: (env, homeId) => {
        return {
            url: `/${env}/homes/:homeId/get-generators`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    addHomeGenerator: (env, homeId, generator) => {
        return {
            url: `/${env}/homes/:homeId/add-generator`,
            method: 'POST',
            route_params: {
                homeId
            },
            post_params: generator
        };
    },
    updateHomeGenerator: (env, homeId, generatorId, generator) => {
        return {
            url: `/${env}/homes/:homeId/update-generator/:generatorId`,
            method: 'PATCH',
            route_params: {
                homeId,
                generatorId
            },
            patch_params: generator
        };
    },
    deleteHomeGenerator: (env, homeId, generatorId) => {
        return {
            url: `/${env}/homes/:homeId/delete-generator/:generatorId`,
            method: 'POST',
            route_params: {
                homeId,
                generatorId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Generators/api.js